import React from 'react';
import { ControlLink, Stack, Text } from '@moda/om';
import { useParams } from 'react-router-dom';
import { TrunkshowPageQuery } from '../../generated/types';
import { hrefFor } from '../../routers';
import { SubscribeEmailToDesignerModule } from '../SubscribeEmailToDesignerModule';

import './TrunkshowEndedHeader.scss';

type Trunkshow = NonNullable<NonNullable<TrunkshowPageQuery['trunkshowPage']>['trunkshow']>;

interface Props {
  trunkshow: Trunkshow;
}

export const TrunkshowEndedHeader: React.FC<Props> = ({
  trunkshow: { designerNames, designerSlugs }
}) => {
  const { vertical = 'women' } = useParams<{ vertical?: string }>();

  if (!designerNames || !designerNames.length) return null;

  const designerName = designerNames[0];

  const designerSlug = designerSlugs?.[0];

  if (!designerName) return null;

  return (
    <Stack className="TrunkshowEndedHeader" alignItems="center" direction="vertical" space={6}>
      <Text className="TrunkshowEndedHeader__title" family="serif" treatment="h3">
        This Trunkshow Has Ended.
      </Text>

      <ControlLink
        to={hrefFor.DesignerPage({
          vertical,
          designerSlug: designerSlug as string
        })}
      >
        Shop {designerName} Latest Arrivals
      </ControlLink>

      <SubscribeEmailToDesignerModule />
    </Stack>
  );
};
